import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { TravelReimbursementModel } from "./travel-reimbursement-data.model";

export class TravelDetailGridPostParams extends GridPostParams {
    id: any =400;
    countFlag: any =1;
}

export class TravelDetailGridModel extends TravelReimbursementModel { }

export class TravelDetailListingModel extends GridModel<TravelDetailGridModel> { }